import NewReleases from "@mui/icons-material/NewReleases";
import { Button } from "@mui/material";

import type { FC } from "react";

export const WhatsNew: FC = () => (
  <Button
    size="small"
    sx={{ color: "text.sidebar", p: 0 }}
    data-analytics-id="sidebar-whats-new"
    variant="text"
    startIcon={<NewReleases />}
    href="/product-portal"
    target="_blank"
  >
    What’s new?
  </Button>
);
